import { render, staticRenderFns } from "./MissionRaceIcon.vue?vue&type=template&id=223af8d7"
import script from "./MissionRaceIcon.vue?vue&type=script&lang=ts"
export * from "./MissionRaceIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports